function scrollIntoViewUnlessIframe (element, options = {}) {
  // Check if the element is inside an iframe
  const isInsideIframe = window !== window.parent

  // If it's inside an iframe, do not scroll
  if (isInsideIframe) {
    return
  }
  // Otherwise, scroll the element into view
  element.scrollIntoView(options)
}


export { scrollIntoViewUnlessIframe }
